exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-b9340e8a]{border-collapse:collapse}.reportTbl th[data-v-b9340e8a]{line-height:30px}.reportTbl th[data-v-b9340e8a],.reportTbl tr td[data-v-b9340e8a]{border:1px solid #ccc!important}.reportTbl tr.textCenter[data-v-b9340e8a],.textCenter[data-v-b9340e8a]{text-align:center}.reportTbl tr.textBold[data-v-b9340e8a],.textBold[data-v-b9340e8a]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9340e8a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/project_forcust_report/insertForm.vue
// module id = 1206
// module chunks = 3